import Stack from "@vapor/react-material/Stack";
import TrashBinHeader from "../table-headers/TrashBinHeader";
import FilterInputs from "./FilterInputs";
import FiltersByCategory from "./FiltersByCategory";
import { DefaultFiltersType, MicroCategory } from "../../../newDocuments/types";
import React from "react";

interface FilterComponentProps {
  handleFilterChange: (name: keyof DefaultFiltersType, value: any) => void;
  filters: DefaultFiltersType;
  macroCategories: Map<string, number>;
  data: DocumentType[];
  documentFilterOption: string;
  filterMicroCategory: MicroCategory[];
  filterTags: string[];
  handleCheckboxChange: (category: MicroCategory) => boolean | void;
  documentListLength: number;
}

const FilterComponent: React.FC<FilterComponentProps> = ({
  handleFilterChange,
  filters,
  macroCategories,
  data,
  documentFilterOption,
  filterMicroCategory,
  filterTags,
  handleCheckboxChange,
  documentListLength,
}) => {
  return (
    <div>
      <Stack direction="column">
        <FiltersByCategory
          handleFilterChange={handleFilterChange}
          filters={filters}
          macroCategories={macroCategories}
          data={data}
        />
        <FilterInputs
          microCategories={filterMicroCategory}
          tags={filterTags}
          handleFilterChange={handleFilterChange}
          handleCheckboxChange={handleCheckboxChange}
        />
        {documentFilterOption === "CESTINO" && (
          <TrashBinHeader documentListLength={documentListLength} />
        )}
      </Stack>
    </div>
  );
};

export default FilterComponent;
